import { createSlice } from "@reduxjs/toolkit";
import { deleteSalesReturn, fetchSalesReturnRecord } from "./SalesReturnRecordThunk";


const initialState = {
  list: [],
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null,
    toDate: null,
  },
  loading: false,
  error: null,
};

const salesReturnRecordSlice = createSlice({
  name: "salesReturnRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalesReturnRecord.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSalesReturnRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchSalesReturnRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteSalesReturn.fulfilled, (state, action) => {
        const { sale_r_id } = action.payload;
        state.list = state.list.filter(
          (row) => row.sale_r_id !== sale_r_id
        );
      });


  },
});

export const { setFilters } = salesReturnRecordSlice.actions;
export default salesReturnRecordSlice.reducer;
